import React, { FC, useCallback } from 'react';

import { SchedulingSettingsV2 } from 'src/components/property-settings/sections/scheduling-settins/SchedulingSettingsV2';
import { SETTINGS_SECTION_TYPES } from 'src/types/SettingsSectionTypes';

import { IScheduledJobConfiguration } from '../../../interfaces/ScheduledJobConfiguration';
import { usePropertySettings } from '../context';
import { setScheduling } from '../state';

export const SchedulingSectionModule: FC = () => {
	const {
		state: { draft, errors }
	} = usePropertySettings();
	const { dispatch } = usePropertySettings();

	// Update this with your own logic to set the property
	const setProperty = useCallback(
		(props: IScheduledJobConfiguration | undefined) => {
			dispatch(setScheduling(props));
		},
		[dispatch]
	);
	return (
		<SchedulingSettingsV2
			property={draft}
			setProperty={setProperty}
			propertyError={errors.find((e) => e.sectionId === SETTINGS_SECTION_TYPES.SCHEDULING)}
		/>
	);
};
